
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import eventBus from "@/utils/eventBus";
import draggable from 'vuedraggable';
import SearchItem from './selectPollingSearchItem.vue';
import { checkPermissionCompany } from "@/utils/permission";
import { UserModule } from '@/store/modules/user';
import { Type } from "@/types/permissionType";

@Component({
  name: "selectPollingSearch",
  components: {
    draggable,
    SearchItem
  },
})
export default class extends Vue {
  private formSearch: any = {
    rangesTime: [],
    person: '',
    telephone: '',
    device: '',
    event: '',
    check:'',
    valid:'',
    customer:'',
  }

  private searchArray: any = []
  private showSearchArray: any = []
  private isToggle = false
  private checkList: any = []
  private searchKey = ''
  private visiblePopover = false

  created() {
    this.searchKey = "lsjl_search" + this.$route.path;
    let index = this.searchKey.lastIndexOf("/");
    if (index > 0) {
      this.searchKey = this.searchKey.substr(0, index);
    }
    if (localStorage.getItem(this.searchKey)) {
      let local: any = localStorage.getItem(this.searchKey);
      let localParse = JSON.parse(local);
      for (let p = 0; p < localParse.length; p++) {
        localParse[p].fields = '';
      }
      this.searchArray = localParse;
    } else {
      this.searchArray = [
        { fields: this.formSearch.rangesTime, name: '起始时间', id: '1', checked: true, show: true, isClearable: true },
        { fields: this.formSearch.person, name: '联系人', id: '2', checked: true, show: true, isClearable: true },
        { fields: this.formSearch.telephone, name: '联系电话', id: '3', checked: true, show: true, isClearable: true },
        { fields: this.formSearch.device, name: '设备', id: '4', checked: false, show: true, isClearable: true },
        { fields: this.formSearch.event, name: '巡检事件', id: '5', checked: false, show: true, isClearable: true },
        { fields: this.formSearch.check, name: '巡检检查项', id: '8', checked: false, show: true, isClearable: true },
        { fields: this.formSearch.valid, name: '有效', id: '6', checked: false, show: true, isClearable: true },
        { fields: this.formSearch.customer, name: '客户', id: '7', checked: false, show: true, isClearable: true },
      ]
    }
    this.showSearchArray = this.searchArray.filter((v: any) => {
      return v.show === true;
    });

  }

  mounted() {
    for (let i = 0; i < this.searchArray.length; i++) {
      if (this.searchArray[i].id === '7') {
        this.searchArray[i].show = checkPermissionCompany(
          UserModule.getCompanyId,
          Type.CUSTOMER_COMPANY
        );
      }
    }
  }

  handleSearch() {
    const params = {
      start_day: this.formSearch.rangesTime && this.formSearch.rangesTime.length>0 && this.formSearch.rangesTime[0] ? this.formSearch.rangesTime[0] : '',
      end_day: this.formSearch.rangesTime && this.formSearch.rangesTime.length>0 &&this.formSearch.rangesTime[1] ? this.formSearch.rangesTime[1] : '',
      customer_name: this.formSearch.person,
      customer_mobile: this.formSearch.telephone,
      device_id: this.formSearch.device.id ? this.formSearch.device.id : '',
      event_id: this.formSearch.event.id ? this.formSearch.event.id : '',
      check_id: this.formSearch.check.id ? this.formSearch.check.id : '',
      time_valid: this.formSearch.valid ? this.formSearch.valid : '',
      customer_company_id: this.formSearch.customer.customer_company_id ? this.formSearch.customer.customer_company_id : '',
      customer_user_id: this.formSearch.customer.customer_user_id ? this.formSearch.customer.customer_user_id : '',

      // page: 1,
      // size: 10,
    };
    eventBus.$emit("orderPollingSearch", params);
  }
  handleCleanSearch() {
    this.formSearch = {
      rangesTime: [],
      person: '',
      telephone: '',
      device: '',
      event: '',
      check:'',
      customer:'',
    }
    for (let m = 0; m < this.searchArray.length; m++) {
      this.searchArray[m].fields = ''
    }
    this.handleSearch()
  }

  private formReceive(val: any, keyup: any) {
    switch (val.id) {
      case '1':
        this.formSearch.rangesTime = val.fields;
        break;
      case '2':
        this.formSearch.person = val.fields;
        break;
      case '3':
        this.formSearch.telephone = val.fields;
        break;
      case '4':
        this.formSearch.device = val.fields;
        break;
      case '5':
        this.formSearch.event = val.fields;
        break;
      case '6':
        this.formSearch.valid = val.fields;
        break;
      case '7':
        this.formSearch.customer = val.fields;
        break;
      case '8':
        this.formSearch.check = val.fields;
        break;
    }
    if (keyup) {
      this.handleSearch();
    }
  }

  toggleHandle() {
    this.isToggle = !this.isToggle;
  }
  confirmHandle() {
    let setItem: any = [];
    setItem = this.searchArray.filter((t: any) =>
      (!this.checkList.some((ele: any) => ele.id === t.id)) && t.show
    );
    for (let m = 0; m < this.searchArray.length; m++) {
      for (let i = 0; i < setItem.length; i++) {
        if (this.searchArray[m].id === setItem[i].id) {
          this.searchArray[m].checked = false; // 设置取消
        }
      }
    }
    for (let m = 0; m < this.searchArray.length; m++) {
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.searchArray[m].id === this.checkList[i].id) {
          this.searchArray[m].checked = true; // 设置选中
        }
      }
    }
    this.settingLocal();
    this.visiblePopover = false;
  }
  resetHandle() {
    this.checkList = []
    for (let i = 0; i < this.searchArray.length; i++) {
      this.searchArray[i].checked = false
      if (this.searchArray[i].id === '1' || this.searchArray[i].id === '2' || this.searchArray[i].id === '3') {
        this.searchArray[i].checked = true
        this.checkList.push(this.searchArray[i])
      }
    }
    this.settingLocal();
    this.visiblePopover = false;
  }

  settingLocal() {
    localStorage.setItem(this.searchKey, JSON.stringify(this.searchArray));
  }
}
